import script from "./CookiesAlart.vue?vue&type=script&setup=true&lang=js"
export * from "./CookiesAlart.vue?vue&type=script&setup=true&lang=js"

import "./CookiesAlart.vue?vue&type=style&index=0&id=ecb2cdf0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecb2cdf0"]])

export default __exports__